import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import type { VendorListItem } from '../../../services/vendors';

interface VendorsUndispatchableBannerProps {
    vendors: VendorListItem[];
    onOpenVendor: (id: string) => void;
}

// The page's headline fact: an active vendor with no usable ordering method
// silently stops ordering, and nobody is told. Named before any row is read.
export function VendorsUndispatchableBanner({
    vendors,
    onOpenVendor
}: VendorsUndispatchableBannerProps) {
    if (vendors.length === 0) return null;

    return (
        <div className="mx-8 mb-4 flex items-start gap-3 p-4 rounded-xl border border-red-300 bg-red-50">
            <ExclamationTriangleIcon className="h-5 w-5 text-red-700 shrink-0 mt-0.5" />
            <div className="min-w-0">
                <p className="text-sm font-semibold text-red-900">
                    {vendors.length} active{' '}
                    {vendors.length === 1 ? 'vendor cannot' : 'vendors cannot'} be ordered from
                </p>
                <p className="text-xs text-red-900 mt-0.5">
                    Ordering from {vendors.length === 1 ? 'this vendor' : 'these vendors'} silently
                    does nothing until an address is added.
                </p>
                <div className="flex flex-wrap gap-1.5 mt-2">
                    {vendors.map((vendor) => (
                        <button
                            key={vendor.id}
                            type="button"
                            onClick={() => onOpenVendor(vendor.id)}
                            className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-white border border-red-300 text-xs font-semibold text-red-800 hover:bg-red-100 transition-colors"
                        >
                            {vendor.name}
                            <span className="text-red-400 font-normal">
                                {vendor.references.linkedProducts} products
                            </span>
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
}
